export const salesHistoryEmptyViewConfig = {
  title: 'No Sales History, yet',
  description: 'This item has no sales history on the Droppp Marketplace.',
  icon: 'market'
}
